import { Grid, FormControlLabel, Typography, RadioGroup, Radio, Divider } from '@mui/material';
import { FormikProps } from 'formik';
import { FormValues } from '../FormPagePerson';
import { useLanguage } from '../i18n/LanguageContext';

interface RowOfStatementProps {
    formik: FormikProps<FormValues>;
    title: React.ReactNode;
    name: keyof FormValues;
    input?: React.ReactNode;
    additionalInput?: React.ReactNode;
    show?: boolean;
}

const RowOfStatement = ({ formik, title, name, input, additionalInput, show = true }: RowOfStatementProps) => {
    const { values, setFieldValue } = formik;
    const { t } = useLanguage();
    if (!show) return <></>;
    // @ts-ignore
    return (
        <Grid container spacing={2} sx={{ marginTop: '30px' }}>
            <Grid size={{ xs: 12, sm: input ? 7 : 9 }}>

                <Typography sx={{ margin: 0, padding: '0px', fontSize: '16px' }} variant="h6">

                    {title}</Typography>

            </Grid>

            <Grid size={{ xs: 12, sm: input ? 5 : 3 }} sx={{ textAlign: 'right' }}>
            {input ? (
                <div>{input}</div>
            ) : (
                <>
                    <RadioGroup
                        sx={{ justifyContent: 'flex-end' }}
                        row
                        name={name}
                        value={values[name] === true ? 'yes' : values[name] === false ? 'no' : ''}
                        onChange={(e) => setFieldValue(name, e.target.value === 'yes')}
                    >
                        <FormControlLabel value="yes" control={<Radio />} label={t('yes')} />
                        <FormControlLabel value="no" control={<Radio />} label={t('no')} />
                    </RadioGroup>
                    {formik.touched[name] && formik.errors[name] && typeof formik.errors[name] === 'string' && (
                      <Typography color="error" sx={{ fontSize: '12px', marginTop: '5px' }}>
                        {formik.errors[name] as string}
                      </Typography>
                    )}
                </>
            )}

            </Grid>

            {additionalInput && (
                <Grid size={{ xs: 12 }} sx={{ textAlign: 'right' }}>
                    {additionalInput}
                </Grid>
            )}
            <Grid size={{ xs: 12 }}>
                <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.3)' }} />
            </Grid>
        </Grid>
    );
};

export default RowOfStatement;
